import { Button, Col, Form, Input, notification, Radio, Row, Select } from "antd"
import { useEffect, useState } from "react";
import { addProgramApi, updateProgramApi } from "../../../../config/Api";
import { API_ERR_MESSAGE, CHARACTER_PATTERN, CHARACTER_PATTERN_MESSAGE, PHONE_PATTERN } from "../../../../config/constant";


export const UpdateProgram = (props) => {
    const [form] = Form.useForm();
    const { Option } = Select;
    let userId = localStorage.getItem('id')

    // const { name, duration, goal, price } = props.programData;

    const [existAdminPrograms, setExistAdminPrograms] = useState([])
    // get the list of all Focus Health Areas
    useEffect(() => {
        form.resetFields()
        if (props.buttonName !== "ADD") {
            if (props.editProgramRecord) {
                let record = props.editProgramRecord;
                form.setFieldsValue({
                    "plan_title": record.name,
                    // "plan_duration": record.duration,
                    "price": record.price,
                    "plan_description": record.plan_description,
                    // "frequency_of_call": record.frequency_of_call,
                    // "health_focus_area": record.health_focus_area_id
                });
            }
        }


    })

    // handle sunmit event call
    //==============================
    const onFinish = (values) => {

        // const data = {
        //     "name": values.name,
        //     "active_clients": values.active_clients,
        //     "price": values.price,
        //     "plan_status": values.plan_status
        // }
        if (props.buttonName == "ADD") {
            const data =
            {
                "name": values.plan_title,
                // "duration": values.plan_duration,
                "price": values.price,
                "plan_description": values.plan_description,
                // "frequency_of_call": values.frequency_of_call,
                "status": true
            }
            addProgramApi(data)
                .then((res) => {
                    if (res.status == 200) {
                        notification.success({
                            message: "Program added successfully",
                        });
                        props.getlistProgram()
                        props.setIsModalVisible(false)
                    }
                })
                .catch((err) => {
                    notification.error({
                        message: API_ERR_MESSAGE,
                    });
                });
        }
        else {
            const data =
            {
                "name": values.plan_title,
                // "duration": values.plan_duration,
                "price": values.price,
                "plan_description": values.plan_description,
                // "frequency_of_call": values.frequency_of_call,
                "status": props.editProgramRecord.status,
            }
            updateProgramApi(props.editProgramRecord.id, data)
                .then((res) => {
                    if (res.status == 200) {
                        notification.success({
                            message: "Program Update successfully",
                        });
                        props.getlistProgram()
                        props.setIsModalVisible(false)
                    }
                })
                .catch((err) => {
                    notification.error({
                        message: API_ERR_MESSAGE,
                    });
                });
        }
    };
    const resetData = () => {
        form.resetFields()
    };

    const existProgram = [
        {
            "id": 11,
            "name": "General Plan",
            "duration": "30",
            "price": "1500",
            "plan_description": "general plan description",
            "frequency_of_call": "Twice a week",
            "plan_features": "plan features",
            "user_id": 16,
            "created_at": "2023-11-08T06:02:22.000000Z",
            "updated_at": "2023-11-08T06:02:22.000000Z",
            "status": true,
            "health_focus_area_id": 2,
            "health_focus_area": {
                "id": 2,
                "name": "PCOS Management",
                "status": true,
                "created_at": "2022-12-26T07:24:54.000000Z",
                "updated_at": "2023-02-24T12:32:48.000000Z"
            }
        }
    ]


    const hanldeProgramSelection = (programId) => {
        if (props?.programsListData && programId) {
            if (props?.programsListData.length > 0) {
                const programDetails = props?.programsListData.find(record => record?.id == programId)

                console.log("programDetails", programDetails);
                form.setFieldsValue({
                    "plan_title": programDetails.name,
                    // "plan_duration": programDetails.duration,
                    "price": programDetails.price,
                    "plan_description": programDetails.plan_description,
                    // "frequency_of_call": programDetails.frequency_of_call,
                    // "health_focus_area": programDetails.health_focus_area_id
                })
            }
        }
    }
    console.log("props?.programsListData", props?.programsListData, userId);
    return (
        <Form
            name="addPlanPricingForm"
            className="addPlanPricingForm"
            form={form}
            onFinish={onFinish}
        >
            <div className="logoSection">
                <h4 className="mb-0">{props.buttonName == 'UPDATE' ? 'Update' : "Add"} Program</h4>
            </div>
            <Row gutter={[16, { xs: 8, sm: 16, md: 24, lg: 8 }]} className="mt-3">
                <Col xs={24} md={16} xl={11} xxl={8}>
                    <label className="form-input-label">
                        Exist Plans
                    </label><br />

                    <Select
                        showSearch
                        filterOption={(inputValue, option) =>
                            option?.children?.toLowerCase().includes(inputValue?.toLowerCase())
                        }
                        style={{ width: "100%" }}
                        className="mt-2"
                        onChange={(e) => hanldeProgramSelection(e)}
                    >
                        {props?.programsListData && props?.programsListData?.length > 0 &&
                            props?.programsListData?.map(option => (
                                //  existProgram.length > 0 && existProgram.map(option => (
                                //  existProgram.length > 0 && existProgram.map(option => (
                                // display admin program by comparing login nutritionist id and login user id   
                                option?.user_id != userId &&
                                <Option value={option.id} key={option.id}>{option.name}</Option>
                            ))}
                    </Select>
                </Col>
                <Col xs={24} md={16} xl={11} xxl={8}>
                    <label className="form-input-label">
                        Plan title
                        <span className="asterik"> *</span>
                    </label>
                    <Form.Item
                        name="plan_title"
                        rules={[
                            {
                                required: true,
                                message: "Please Enter Plan title!",
                            },
                            {
                                pattern: CHARACTER_PATTERN,
                                message: CHARACTER_PATTERN_MESSAGE,
                            }
                        ]}
                    >
                        <Input placeholder="Enter Plan Title" className="mt-2 p-2" />
                    </Form.Item>
                </Col>
                <Col xs={24} md={16} xl={11} xxl={8}>
                    <label className="form-input-label">
                        Price
                        {/* <span className="asterik"> *</span> */}
                    </label>
                    <Form.Item
                        name="price"
                        rules={[
                            { required: true, message: "Please insert price!" },
                            {
                                pattern: PHONE_PATTERN,
                                message: "Please insert valid data!",
                            },
                        ]}
                    >
                        <Input placeholder="Enter price" className="mt-2 p-2" />
                    </Form.Item>
                </Col>
                {/* <Col xs={24} md={16} xl={11} xxl={8}>
                    <label className="form-input-label">
                        Plan Duration(In Days)
                    </label>
                    <Form.Item
                        name="plan_duration"
                        rules={[
                            { required: true, message: "Please insert Plan Duration(In Days)!" },
                            {
                                pattern: PHONE_PATTERN,
                                message: "Please insert valid data!",
                            },
                        ]}
                    >
                        <Input placeholder="Enter Plan Duration" className="mt-2 p-2" />
                    </Form.Item>
                </Col> */}
                <Col xs={24} md={16} xl={11} xxl={24}>
                    <label className="form-input-label">
                        Plan Description
                        <span className="asterik"> *</span>
                    </label>
                    <Form.Item
                        name="plan_description"
                        rules={[
                            { required: true, message: "Please insert Plan Description!" },
                            // {
                            //     pattern: PHONE_PATTERN,
                            //     message: "Please insert valid data!",
                            // },
                        ]}
                    >
                        <Input.TextArea
                            placeholder="Enter Plan Description"
                            // showCount
                            // maxLength={100}
                            className="mt-2 p-2"
                        />
                    </Form.Item>
                </Col>
                {/* <Col xs={24} md={16} xl={11} xxl={24} className="align-self-center">
                    <label className="form-input-label">
                        Frequency of calls
                    </label>
                    <Form.Item
                        name="frequency_of_call"
                        rules={[
                            // { required: true, message: "Please insert Frequency of calls!" },
                        ]}
                    >
                        <Radio.Group className="mt-2">
                            <Radio value="Once a week"> Once a week</Radio>
                            <Radio value="Twice a week">Twice a week</Radio>
                            <Radio value="Daily">Daily</Radio>
                        </Radio.Group>
                    </Form.Item>
                </Col> */}
                <Col span={24} className="text-center">
                    <Button htmlType="submit" className="submit-button b-0 rounded">
                        {props.buttonName}
                    </Button>
                    <Button onClick={() => resetData()} className="reset-button ms-4 b-0 rounded">
                        RESET
                    </Button>
                </Col>
            </Row>
        </Form>

    )
}